var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"market"},[_c('platform'),_c('com-list',{attrs:{"data":_vm.services,"title":"我们提供的营销服务","subtitle":"为企业提供技术产品的推广、销售线索的获取、技术品牌的打造、开发者生态的共建等"}}),_c('com-partner',{attrs:{"partners":_vm.partners}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }